'use strict';

// 3p
import React from 'react';
import { render } from 'react-dom';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
// import { createBrowserHistory } from "history";
// const customHistory = createBrowserHistory();

// polyfills
import "core-js/modules/es.object.values";
import "core-js/modules/es.array.find";
import Polyfill from './util/polyfill';
const InitPolyfills = new Polyfill();

// stores, utils
const Globals = require('../../app/globals');
const Strings = require('../../app/shared/Strings');
const GoogleClassroomActions = require('./actions/GoogleClassroomActions');
const GoogleClassroomStore = require('./stores/GoogleClassroomStore');

// load hook for google api used by google classroom (see index.hbs)
global.handle_gapi_load = function() {
    GoogleClassroomActions.setGapiState(Globals.GAPI_LoadState.CLIENT_LOADED);
}

//components
import SignIn from './components/SignedOut/SignIn';
import SignUp from './components/SignedOut/SignUp';
import RegisterFull from './components/SignedOut/RegisterFull';
import ValidateOrganization from './components/SignedOut/ValidateOrganization';
import ResetPassword from './components/SignedOut/ResetPassword';
import RequestResetPassword from './components/SignedOut/RequestResetPassword';
import TAndC from './components/legal/TAndC';
import Privacy from './components/legal/Privacy';

// import Dashboard from './components/Dashboard';
import DashboardNew from './components/DashboardNew/DashboardNew';
import DashboardHome from './components/DashboardNew/DashboardHome';
import ProjectView from './components/ProjectView';
import ProjectAnalyticsView from './components/analytics/ProjectAnalyticsView';
import ActivityView from './components/ActivityView';
import ShortCourseView from './components/ShortCourse/ShortCourseView';
import EditShortCourseView from './components/ShortCourse/EditShortCourseView';
import ReviewShortCourseView from './components/ShortCourse/ReviewShortCourseView';
import PreviewShortCourseView from './components/ShortCourse/PreviewShortCourseView';
import CreateActivityView from './components/CreateActivity';
import GroupView from './components/GroupView';
import PreviewActivityView from './components/PreviewActivityView';
import ActivityMetaTagsView from './components/activity/ActivityMetaTagsView';
import { PreviewActivityEditorView } from './components/PreviewActivityEditorReviewView';
import { PreviewActivityReviewView } from './components/PreviewActivityEditorReviewView';
import EditActivityView from './components/EditActivityView';
import ReviewActivityView from './components/ReviewActivityView';
import ProjectCollaboratorsView from './components/project/ProjectCollaboratorsView';
import AccountSettings from './components/AccountSettings';
import ChannelProjectAnalyticsView from './components/analytics/ChannelProjectAnalyticsView';
// import ChannelActivityAnalyticsView from './components/analytics/ChannelActivityAnalyticsView';
import ProjectActivityAnalyticsView from './components/analytics/ProjectActivityAnalyticsView';
import ProjectShortCourseAnalyticsView from './components/analytics/ProjectShortCourseAnalyticsView';
import ActivityQLAView from './components/analytics/ActivityQLAView';
import IndividualSelectSubscriptionView from './components/subscription/IndividualSelectSubscriptionView';
import OrganizationSubscriptionView from './components/subscription/OrganizationSubscriptionView';
import ActivityShareView from './components/ActivityShareView';

import AdminView from './components/admin/AdminView';
import NotFound from './components/NotFound';

// Route Wrapper Components ===================================================
import { AppRoot, SignedOutOrSignedIn, AuthorSignedOut, AuthorSignedIn, AdminArea } from './routing';
function renderSignedInOrSignedOutComponent(props, Component, title=Strings['en'].page_title.DEFAULT) {
    return <SignedOutOrSignedIn title={title}><Component {...props} /></SignedOutOrSignedIn>;
}

function renderSignedOutComponent(props, Component, title=Strings['en'].page_title.DEFAULT) {
    return <AuthorSignedOut title={title}><Component {...props} /></AuthorSignedOut>;
}

function renderSignedInComponent(props, Component, title=Strings['en'].page_title.DEFAULT) {
    return <AuthorSignedIn title={title}><Component {...props} /></AuthorSignedIn>;
}

function renderAdminComponent(props, Component, title=Strings['en'].page_title.DEFAULT) {
    return <AuthorSignedIn title={title}><AdminArea><Component {...props} /></AdminArea></AuthorSignedIn>;
}

// Route tree =================================================================
render (
    <Router>
        <AppRoot>
            <Switch>
                {/* signed in or signed out*/}
                <Route
                    path="/signup/:token"
                     render={props => renderSignedInOrSignedOutComponent(props, SignUp, Strings['en'].page_title.SIGN_UP)}
                />
                <Route
                    path="/register"
                    render={props => renderSignedInOrSignedOutComponent(props, RegisterFull, Strings['en'].page_title.SIGN_UP)}
                />
                <Route
                    path="/register_org"
                    render={props => renderSignedInOrSignedOutComponent(props, ValidateOrganization, Strings['en'].page_title.SIGN_UP)}
                />
                <Route
                    path="/terms"
                    render={props => renderSignedInOrSignedOutComponent(props, TAndC, Strings['en'].page_title.T_AND_C)}
                />
                <Route
                    path="/privacy"
                    render={props => renderSignedInOrSignedOutComponent(props, Privacy, Strings['en'].page_title.PRIVACY)}
                />
                <Route
                    exact
                    path="/share/:shareId"
                    render={props => renderSignedInOrSignedOutComponent(props, ActivityShareView, Strings['en'].page_title.ACTIVITY_SHARE)}
                />

                {/* signed out*/}
                <Route
                    path="/signin"
                    render={props => renderSignedOutComponent(props, SignIn)}
                />
                <Route
                    path="/reset_password"
                    render={props => renderSignedOutComponent(props, ResetPassword, Strings['en'].page_title.FORGOT_PASSWORD)}
                />
                <Route
                    path="/request_password_reset"
                    render={props => renderSignedOutComponent(props, RequestResetPassword, Strings['en'].page_title.FORGOT_PASSWORD)}
                />

                {/* signed in */}
                <Route
                    exact
                    path="/"
                    render={props => renderSignedInComponent(props, DashboardHome, Strings['en'].page_title.DASHBOARD)}
                />
                <Route
                    exact
                    path="/dashboard_author"
                    render={props => renderSignedInComponent({ ...props, role: Globals.users.local_role_type.AUTHOR }, DashboardNew, Strings['en'].page_title.DASHBOARD)}
                />
                <Route
                    exact
                    path="/dashboard_author/view/:viewTokenDashboard"
                    render={props => renderSignedInComponent({ ...props, role: Globals.users.local_role_type.AUTHOR }, DashboardNew, Strings['en'].page_title.DASHBOARD)}
                />
                <Route
                    exact
                    path="/dashboard_author/view/:viewTokenDashboard/view/:viewTokenAuthorDashboard"
                    render={props => renderSignedInComponent({ ...props, role: Globals.users.local_role_type.AUTHOR }, DashboardNew, Strings['en'].page_title.DASHBOARD)}
                />
                <Route
                    exact
                    path="/dashboard_author/view/:viewTokenDashboard/view/:viewTokenAuthorDashboard/:channelId"
                    render={props => renderSignedInComponent({ ...props, role: Globals.users.local_role_type.AUTHOR }, DashboardNew, Strings['en'].page_title.DASHBOARD)}
                />
                <Route
                    exact
                    path="/dashboard_author/view/:viewTokenDashboard/view/:viewTokenAuthorDashboard/:channelId/:viewTokenChannelDashboard"
                    render={props => renderSignedInComponent({ ...props, role: Globals.users.local_role_type.AUTHOR }, DashboardNew, Strings['en'].page_title.DASHBOARD)}
                />
                <Route
                    exact
                    path="/dashboard_author/view/:viewTokenDashboard/view/:viewTokenAuthorDashboard/:channelId/:viewTokenChannelDashboard/:subViewTokenChannelDashboard"
                    render={props => renderSignedInComponent({ ...props, role: Globals.users.local_role_type.AUTHOR }, DashboardNew, Strings['en'].page_title.DASHBOARD)}
                />
                <Route
                    exact
                    path="/dashboard_author/view/:viewTokenDashboard/course/:viewTokenCourseId"
                    render={props => renderSignedInComponent({ ...props, role: Globals.users.local_role_type.AUTHOR }, DashboardNew, Strings['en'].page_title.DASHBOARD)}
                />
                <Route
                    exact
                    path="/dashboard_author/group/:group_id"
                    render={props => renderSignedInComponent(props, GroupView, Strings['en'].page_title.GROUPS)}
                />
                
                
                <Route
                    exact
                    path="/dashboard_student"
                    render={props => renderSignedInComponent({ ...props, role: Globals.users.local_role_type.STUDENT }, DashboardNew, Strings['en'].page_title.DASHBOARD)}
                />
                <Route
                    exact
                    path="/dashboard_student/view/:viewTokenDashboard"
                    render={props => renderSignedInComponent({ ...props, role: Globals.users.local_role_type.STUDENT }, DashboardNew, Strings['en'].page_title.DASHBOARD)}
                />
                <Route
                    exact
                    path="/dashboard_student/view/:viewTokenDashboard/course/:viewTokenCourseId"
                    render={props => renderSignedInComponent({ ...props, role: Globals.users.local_role_type.STUDENT }, DashboardNew, Strings['en'].page_title.DASHBOARD)}
                />
                <Route
                    exact
                    path="/dashboard"
                    render={props => renderSignedInComponent(props, DashboardHome, Strings['en'].page_title.DASHBOARD)}
                />
                {/* <Route
                    exact
                    path="/dashboard/view/:viewTokenDashboard"
                    render={props => renderSignedInComponent(props, Dashboard, Strings['en'].page_title.DASHBOARD)}
                />
                <Route
                    exact
                    path="/dashboard/:channelId"
                    render={props => renderSignedInComponent(props, Dashboard, Strings['en'].page_title.DASHBOARD)}
                />
                <Route
                    exact
                    path="/dashboard/:channelId/:viewToken"
                    render={props => renderSignedInComponent(props, Dashboard, Strings['en'].page_title.DASHBOARD)}
                /> */}

                <Route
                    exact
                    path="/project/:channel/:projectID"
                    render={props => renderSignedInComponent(props, ProjectView, Strings['en'].page_title.PROJECT_VIEW)}
                />
                <Route
                    path="/project/:channelId/:projectId/analytics" 
                    render={props => renderSignedInComponent(props, ProjectAnalyticsView, Strings['en'].page_title.PROJECT_ANALYTICS_VIEW)}
                />
                <Route
                    path="/project/:channel/:projectID/editAccess" 
                    render={props => renderSignedInComponent(props, ProjectCollaboratorsView, Strings['en'].page_title.PROJECT_COLLABS_VIEW)}
                />
                <Route
                    path="/project/:channel/:projectID/create-activity" 
                    render={props => renderSignedInComponent(props, CreateActivityView, Strings['en'].page_title.ACTIVITY_CREATE_VIEW)}
                />

                <Route
                    path="/project/:channelId/:projectId/activity/:activityId"
                    exact
                    render={props => renderSignedInComponent(props, ActivityView, Strings['en'].page_title.ACTIVITY_VIEW)}
                />

                <Route
                    exact
                    path="/project/:channel/:projectID/activity/:activityId/preview"
                    render={props => renderSignedInComponent(props, PreviewActivityView, Strings['en'].page_title.ACTIVITY_PREVIEW)}
                />
                <Route
                    exact
                    path="/project/:channel/:projectID/activity/:activityId/preview/:activityVersion"
                    render={props => renderSignedInComponent(props, PreviewActivityView, Strings['en'].page_title.ACTIVITY_PREVIEW)}
                />

                <Route
                    exact
                    path="/project/:channel/:projectID/activity/:activityId/edit"
                    render={props => renderSignedInComponent(props, EditActivityView, Strings['en'].page_title.ACTIVITY_EDIT)}
                />
                <Route
                    exact
                    path="/project/:channel/:projectID/activity/:activityId/edit/:activityVersion"
                    render={props => renderSignedInComponent(props, EditActivityView, Strings['en'].page_title.ACTIVITY_EDIT)}
                />

                <Route
                    exact
                    path="/project/:channelId/:projectId/activity/:activityId/preview_editor"
                    render={props => renderSignedInComponent(props, PreviewActivityEditorView, Strings['en'].page_title.ACTIVITY_EDIT)}
                />
                <Route
                    exact
                    path="/project/:channelId/:projectId/activity/:activityId/preview_editor/:activityVersion"
                    render={props => renderSignedInComponent(props, PreviewActivityEditorView, Strings['en'].page_title.ACTIVITY_EDIT)}
                />

                <Route
                    exact
                    path="/project/:channelId/:projectId/activity/:activityId/review"
                    render={props => renderSignedInComponent(props, ReviewActivityView, Strings['en'].page_title.ACTIVITY_REVIEW)}
                />
                <Route
                    exact
                    path="/project/:channelId/:projectId/activity/:activityId/review/:activityVersion"
                    render={props => renderSignedInComponent(props, ReviewActivityView, Strings['en'].page_title.ACTIVITY_REVIEW)}
                />

                <Route
                    exact
                    path="/project/:channelId/:projectId/activity/:activityId/review_editor"
                    render={props => renderSignedInComponent(props, PreviewActivityReviewView, Strings['en'].page_title.ACTIVITY_REVIEW)}
                />
                <Route
                    exact
                    path="/project/:channelId/:projectId/activity/:activityId/review_editor/:activityVersion"
                    render={props => renderSignedInComponent(props, PreviewActivityReviewView, Strings['en'].page_title.ACTIVITY_REVIEW)}
                />
                

                <Route
                    path="/project/:channel/:projectID/activity/:activityId/meta_tags"
                    render={props => renderSignedInComponent(props, ActivityMetaTagsView, Strings['en'].page_title.ACTIVITY_META_TAGS)}
                />

                <Route
                    path="/project/:channelId/:projectId/short_course/:shortCourseId"
                    exact
                    render={props => renderSignedInComponent(props, ShortCourseView)}
                />
                <Route
                    exact
                    path="/project/:channelId/:projectId/short_course/:shortCourseId/edit"
                    render={props => renderSignedInComponent(props, EditShortCourseView)}
                />
                <Route
                    exact
                    path="/project/:channelId/:projectId/short_course/:shortCourseId/edit/:shortCourseVersion"
                    render={props => renderSignedInComponent(props, EditShortCourseView)}
                />

                <Route
                    exact
                    path="/project/:channelId/:projectId/short_course/:shortCourseId/review"
                    render={props => renderSignedInComponent(props, ReviewShortCourseView)}
                />
                <Route
                    exact
                    path="/project/:channelId/:projectId/short_course/:shortCourseId/review/:shortCourseVersion"
                    render={props => renderSignedInComponent(props, ReviewShortCourseView)}
                />
                
                <Route
                    exact
                    path="/project/:channelId/:projectId/short_course/:shortCourseId/preview"
                    render={props => renderSignedInComponent(props, PreviewShortCourseView)}
                />
                <Route
                    exact
                    path="/project/:channelId/:projectId/short_course/:shortCourseId/preview/:shortCourseVersion"
                    render={props => renderSignedInComponent(props, PreviewShortCourseView)}
                />

                <Route
                    path="/group/:group_id"
                    render={props => renderSignedInComponent(props, GroupView, Strings['en'].page_title.GROUPS)}
                />

                <Route
                    path="/analytics/:channelId/projects"
                    exact
                    render={props => renderSignedInComponent(props, ChannelProjectAnalyticsView, Strings['en'].page_title.CHANNEL_PROJECT_ANALYTICS)}
                />
                <Route
                    path="/analytics/:channelId/projects/:projectId"
                    exact
                    render={props => renderSignedInComponent(props, ChannelProjectAnalyticsView, Strings['en'].page_title.CHANNEL_PROJECT_ANALYTICS)}
                />
                {/* TODO not a valid path? viewing "all channel activities" out of project scope isn't used. never linked to
                <Route
                    path="/analytics/:channelId/activities"
                    exact
                    render={props => renderSignedInComponent(props, ChannelActivityAnalyticsView)}
                />
                */}
                {/*
                <Route
                    path="/analytics/:channelId/activities/:projectId/:activityId"
                    exact
                    render={props => renderSignedInComponent(props, ChannelActivityAnalyticsView, Strings['en'].page_title.ACTIVITY_ANALYTICS)}
                />*/}

                <Route
                    path="/analytics/:channelId/:projectId/activities"
                    exact
                    render={props => renderSignedInComponent(props, ProjectActivityAnalyticsView, Strings['en'].page_title.PROJECT_ACTIVITY_ANALYTICS)}
                />
                <Route
                    path="/analytics/:channelId/:projectId/activities/:activityId"
                    exact
                    render={props => renderSignedInComponent(props, ProjectActivityAnalyticsView, Strings['en'].page_title.PROJECT_ACTIVITY_ANALYTICS)}
                />

                <Route
                    path="/analytics/:channelId/:projectId/short_course"
                    exact
                    render={props => renderSignedInComponent(props, ProjectShortCourseAnalyticsView, Strings['en'].page_title.PROJECT_COURSE_ANALYTICS)}
                />
                <Route
                    path="/analytics/:channelId/:projectId/short_course/:shortCourseId"
                    exact
                    render={props => renderSignedInComponent(props, ProjectShortCourseAnalyticsView, Strings['en'].page_title.PROJECT_COURSE_ANALYTICS)}
                />

                <Route
                    path="/analytics/:channelId/:projectId/activities/:activityId/qla"
                    exact
                    render={props => renderSignedInComponent(props, ActivityQLAView, Strings['en'].page_title.ACTIVITY_QLA)}
                />

                <Route
                    path="/settings"
                    exact
                    render={props => renderSignedInComponent(props, AccountSettings, Strings['en'].page_title.ACCOUNT_SETTINGS)}
                />
                <Route
                    path="/settings/subscription"
                    exact
                    render={props => renderSignedInComponent(props, IndividualSelectSubscriptionView, Strings['en'].page_title.SUBSCRIPTION)}
                />
                <Route
                    path="/settings/organization/subscription"
                    exact
                    render={props => renderSignedInComponent(props, OrganizationSubscriptionView, Strings['en'].page_title.SUBSCRIPTION)}
                />

                {/* admin area */}
                <Route
                    path="/admin/settings"
                    exact
                    render={props => renderAdminComponent(props, AdminView, Strings['en'].page_title.ADMIN)}
                />
                <Route
                    path="/admin/settings/:viewToken"
                    render={props => renderAdminComponent(props, AdminView, Strings['en'].page_title.ADMIN)}
                />
                
                {/* no match */}
                <Route render={props => renderSignedInOrSignedOutComponent(props, NotFound, Strings['en'].page_title.NOT_FOUND)} />
            </Switch>
        </AppRoot>
    </Router>,
    document.getElementById('app')
);
// ============================================================================